export default __webpack_public_path__ + "static/about-us-nicola-ec25fe4b89f90452f4dba5bf8045631c.webp";